<template>
  <f7-page no-swipeback>
    <f7-navbar>
      <f7-nav-left>
        <f7-link icon-ios="f7:menu" icon-md="material:menu" panel-open="left"></f7-link>
      </f7-nav-left>
      <f7-nav-title>{{$t('title.myTransactions')}}</f7-nav-title>
      <f7-nav-right>
        <f7-link :class="{disabled: !hasTransactions}" @click="openSearch" icon-ios="f7:search_fill"
                 icon-md="material:search"/>
      </f7-nav-right>
      <f7-subnavbar sliding>
        <f7-segmented>
          <f7-button :href="links.myCard" tab-link>{{$t('title.overview')}}</f7-button>
          <f7-button :href="links.spend" tab-link tab-link-active>{{$t('title.spend')}}</f7-button>
        </f7-segmented>
        <f7-searchbar ref="spend_search" expandable search-in=".item-title" @input="onInput"/>
      </f7-subnavbar>
    </f7-navbar>
    <transaction-list ref="transactions" :transactions="myExpenses"/>
    <f7-block>
      <p v-if="!hasTransactions">{{$t('text.noSpend')}}</p>
    </f7-block>
    <main-toolbar slot="fixed" :active="isManager ? 2 : 3"/>
  </f7-page>
</template>

<script>
  import helpers from '@/utils/helpers'
  import MainToolbar from '../components/main-toolbar'
  import TransactionList from '../components/transaction-list'

  export default {
    name: 'my-spend',
    components: {
      TransactionList,
      MainToolbar,
    },
    computed: {
      hasTransactions () {
        return this.myExpenses.length > 0
      }
    },
    created () {
      this.$store.dispatch('fetchExpenses')
      this.$bus.on('transaction-update', () => this.$store.dispatch('fetchExpenses'))
    },
    methods: {
      onInput () {
        const searchBar = this.$refs.spend_search.f7Searchbar
        if (!searchBar.searchContainer) {
          searchBar.searchContainer = this.$refs.transactions.$refs.list.$el
          searchBar.$searchContainer = this.$f7.$(searchBar.searchContainer)
        }
      },
      openSearch () {
        this.$refs.spend_search.enable()
        this.$refs.spend_search.$el.getElementsByTagName('input')[0].focus()
      }
    },
    mixins: [helpers]
  }
</script>

<style scoped>

</style>
